import { useEffect } from "react"

export const useEvent = (event: keyof WindowEventMap, fn: () => void) => {
    useEffect(() => {
        window.addEventListener(event, fn);
        return () => window.removeEventListener(event, fn)
    });
}

